// dependencies
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/system';
import { primaryTheme } from './Theme';

// HOCs
import OpenRoute from './HOCs/OpenRoute';
import SellerRoute from './HOCs/SellerRoute';
import UserRoute from './HOCs/UserRoute';

// Pages
import LandingPage from './pages/LandingPage/LandingPage';
import AboutPage from './pages/AboutPage/AboutPage';
import AuthPage from './pages/AuthPage/AuthPage';
import BecomeASellerPage from './pages/BecomeASellerPage/BecomeASellerPage';
import CategoriesPage from './pages/CategoriesPage/CategoriesPage';
import GigInfoPage from './pages/GigInfoPage/GigInfoPage';
import GigListPage from './pages/GigListPage/GigListPage';
import SellerRegistrationPage from './pages/SellerRegistrationPage/SellerRegistrationPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import MyProfilePage from './pages/MyProfilePage/MyProfilePage';
import AddNewGigPage from './pages/AddNewGigPage/AddNewGigPage';
import PublicProfilePage from './pages/PublicProfilePage/PublicProfilePage';
import PlaceOrderPage from './pages/OrderConfirmationPage/OrderConfirmationPage';

// redux imports
import { store } from "./redux/store";
import { Provider } from 'react-redux';

import MyOrders from './pages/MyOrdersPage/MyOrders';
import BuyerMessagePage from './pages/BuyerMessagePage/BuyerMessagePage';
import PaymentSuccessScreen from './components/PageComponents/PaymentScreensComponent/PaymentSuccessScreen/PaymentSuccessScreen';
import PaymentFailureScreen from './components/PageComponents/PaymentScreensComponent/PaymentFailureScreen/PaymentFailureScreen';
import SellerProfileEditPage from './components/PageComponents/SellerProfileEditPage/SellerProfileEditPage';
import FAQsPage from './pages/FAQs_Page/FAQsPage';
import ContactUsPage from './pages/ContactUsPage/ContactUsPage';
import OrderDetailsPage from './pages/OrderDetailsPage/OrderDetailsPage';
import AdminRoute from './HOCs/AdminRoute';
import AdminPanelPage from './pages/AdminPages/AdminPanelPage/AdminPanelPage';
import TermsOfService from './components/LegalDocComponents/TermsOfService';
import PrivacyPolicy from './components/LegalDocComponents/PrivacyPolicy';
import Clarity from '@microsoft/clarity';
import { EnvironmentManager } from './services/EnvironmentManager/EnvironmentManager';
import { ChatInitializer } from './components/UtilityComponents/ChatInitializer/ChatInitializer';
import { FreelancerDashboard } from './pages/FreelancerDashboardPage/FreelancerDashboard';

// Initialize Clarity with your project ID
const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

// Only initialize Clarity for Production users
if (projectId && EnvironmentManager.isProdEnv()) {
  Clarity.init(projectId)
}


function App() {
  return (
    <>
      <Provider store={store}>
        <ThemeProvider theme={primaryTheme}>
          {/* Initialize chat connection once at app level */}
          <ChatInitializer />

          <Router>
            <Routes>

              {/* ================= Open Routes - No Login Required =============== */}

              <Route path="/" element={<OpenRoute components={[LandingPage]}/>}/>
              <Route path="/login" element={<OpenRoute components={[AuthPage]}/>}/>
              <Route path="/register" element={<OpenRoute components={[AuthPage]}/>}/>
              <Route path="/become-a-freelancer" element={<OpenRoute components={[BecomeASellerPage]}/>}/>
              <Route path="/about" element={<OpenRoute components={[AboutPage]}/>}/>
              <Route path="/terms-of-service" element={<OpenRoute components={[TermsOfService]}/>}/>
              <Route path="/privacy-policy" element={<OpenRoute components={[PrivacyPolicy]}/>}/>
              <Route path="/FAQs" element={<OpenRoute components={[FAQsPage]}/>}/>
              <Route path="/contact-us" element={<OpenRoute components={[ContactUsPage]}/>}/>
              <Route path="/categories" element={<OpenRoute components={[CategoriesPage]}/>}/>
              <Route path="/categories/subcategory/:subcategoryId/giglist" element={<OpenRoute components={[GigListPage]}/>}/>
              <Route path="/profile/:id" element={<OpenRoute components={[PublicProfilePage]}/>}/>
              <Route path="/gig/:gigId" element={<OpenRoute components={[GigInfoPage]}/>}/>


              {/* ================= User Routes - User Login Required =============== */}

              <Route path="/become-a-freelancer/register" element={<UserRoute components={[SellerRegistrationPage]} />} />
              <Route path="/my-profile" element={<UserRoute components={[MyProfilePage]} />} />
              <Route path="/my-orders" element={<UserRoute components={[MyOrders]} />} />
              <Route path="/my-messages" element={<UserRoute components={[BuyerMessagePage]} />} />
              <Route path="/create-order" element={<UserRoute components={[PlaceOrderPage]}/>}/>
              <Route path="/payment-success" element={<UserRoute components={[PaymentSuccessScreen]} />} />
              <Route path="/payment-failure" element={<UserRoute components={[PaymentFailureScreen]} />} />
              <Route path="/order-details/:orderId" element={<UserRoute components={[OrderDetailsPage]}/>} />
              
              {/* ================= Freelancer Routes - Freelancer Login Required =============== */}

              <Route path="/freelancer-dashboard/*" element={<SellerRoute components={[FreelancerDashboard]} />} />
              <Route path="/freelancer-dashboard/add-new-gig" element={<SellerRoute components={[AddNewGigPage]} />} />
              <Route path="/profile-edit" element={<SellerRoute components={[SellerProfileEditPage]} />} />


              {/* ================= Admin Routes - Admin Login Required =============== */}
              <Route path="/admin/*" element={<AdminRoute components={[AdminPanelPage]} />} />

              {/* ================= Default Route - 404 Not found Page =============== */}
              <Route path='*' element={<NotFoundPage />} />
             

            </Routes>
          </Router>

        </ThemeProvider>
      </Provider>
    </>
  );
}

export default App;
